module.exports = __webpack_public_path__ + "static/media/resume.d1db4822.pdf";